import { Button } from '@mui/material';
import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { object, string } from 'zod';
import AuthLayout from '../../components/AuthLayout';
import Popup from '../../components/common/Popup/Popup';
import ResetPasswordComponent from '../../components/ResetPassword';
import getAPIUrl from '../../config';
import { putApi } from '../../utils/apiCalls';
import styles from './styles';
import { trimFormData } from '../../utils/helpers';

const ResetPassword = () => {
    const [showError, setShowError] = useState<boolean>(false);
    const resetPassValidationSchema = object({
        password: string().regex(/(?=.*\d)(?=.*[A-Z])(?=.*[@$!%*#?&^_-]).{8,}/),
        repeatPassword: string().regex(/(?=.*\d)(?=.*[A-Z])(?=.*[@$!%*#?&^_-]).{8,}/),
    }).refine((data) => data.password === data.repeatPassword, {
        message: "Passwords don't match",
        path: ['repeatPassword'],
    });
    const { search } = useLocation();
    const token = new URLSearchParams(search).get('token');

    const [resetPassValues, setResetPassValues] = useState<{ password: string; repeatPassword: string }>({
        password: '',
        repeatPassword: '',
    });
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);
    const [submitting, setSubmitting] = useState<boolean>(false);

    const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        const validate = resetPassValidationSchema.safeParse(trimFormData(resetPassValues));
        if (validate.success) {
            try {
                setSubmitting(true);
                await putApi(`${getAPIUrl()}/admins/update-admin-password`, { ...resetPassValues, token });
                setOpen(true);
            } catch (error: any) {
                setShowError(true);
                setResetPassValues({
                    password: '',
                    repeatPassword: '',
                });
            } finally {
                setSubmitting(false);
            }
        } else {
            setShowError(true);
            setResetPassValues({
                password: '',
                repeatPassword: '',
            });
        }
    };

    const handleInput = (e: React.ChangeEvent<HTMLInputElement>): void => {
        const { value, name } = e.currentTarget;
        setResetPassValues({
            ...resetPassValues,
            [name]: value,
        });
    };
    const goToSignIn = () => {
        setOpen(false);
        navigate('/');
    };

    return (
        <>
            <Popup
                id="reset_password_success"
                open={open}
                title="Success!"
                textAlign="center"
                handleClose={() => null}
                description={<>Your password was created successfully. You may go back to Sign In.</>}
            >
                <Button id="stayLoggedIn" variant="contained" sx={styles.alertPopUp} fullWidth onClick={goToSignIn}>
                    Continue To Sign In
                </Button>
            </Popup>
            <AuthLayout
                component={
                    <ResetPasswordComponent
                        handleSubmit={onSubmit}
                        showError={showError}
                        handleInput={handleInput}
                        credentials={resetPassValues}
                        submitting={submitting}
                    />
                }
            />
        </>
    );
};
export default ResetPassword;
